import * as THREE from 'three'
import {
  NidoId,
  NidoPosition,
  NidoSocketId,
} from '~/service/experience/world/nido/enum'
import { NidoCage } from '~/service/experience/world/nido/parts/NidoCage'
import { Nido } from '~/service/experience/world/nido/Nido'
import { NidoLowBackrest } from '~/service/experience/world/nido/parts/NidoTexturePart'
import NidoSocket from '~/service/experience/world/nido/parts/NidoSocket'

type NidoSavedPart = {
  inverted: boolean
  offset: number
  position: NidoPosition
  isCorner: boolean
}

type NidoSavedTable = NidoSavedPart & {
  type: NidoPartName.TABLE
  lowBackrest: NidoLowBackrest
  socket: NidoSocket
}

type NidoSavedSeat = NidoSavedPart & {
  color: string
  type: NidoPartName.SEAT
  lowBackrest: NidoLowBackrest
  socket: NidoSocket
}

type NidoSavedSeatOrTable = NidoSavedTable | NidoSavedSeat

export type NidoPartParameters = {
  offset: number
  inverted: boolean
  position: NidoPosition
}

export interface NidoSavedParts {
  bottom: NidoCage
  left?: NidoSavedSeatOrTable
  center?: NidoSavedSeatOrTable
  right?: NidoSavedSeatOrTable
}

export default class NidoPart {
  code: string
  id: NidoId | NidoSocketId
  offset: number
  inverted: boolean
  position: NidoPosition
  model: THREE.Mesh
  component: Component
  scene: THREE.Group

  constructor(
    parent: Nido,
    scene: THREE.Group,
    model: THREE.Mesh,
    parameters: NidoPartParameters,
    code: string,
    id: NidoId | NidoSocketId
  ) {
    this.code = code
    this.id = id
    this.offset = parameters.offset
    this.inverted = parameters.inverted
    this.position = parameters.position
    this.scene = scene

    this.model = model.clone()

    this.model.position.x += parameters.offset

    // this.model.traverse((child) => (child.castShadow = true))
    // I think this is a compromise between realistic configurator and best UX - otherwise you aren't able to see pillows in some cases
    // this.model.receiveShadow = true

    scene.add(this.model)
  }

  setComponent(component: Component) {
    this.component = shallowRef(component)
  }

  invert() {
    this.inverted = !this.inverted
    this.model.scale.z *= -1
    const configurator = useConfigurator()
    configurator.addedChair()
  }

  remove() {
    this.scene.remove(this.model)
  }

  getParts(): NidoPart[] {
    return [this]
  }

  toJSON() {
    const obj = {
      offset: this.offset,
      position: this.position,
      inverted: this.inverted,
      code: this.code,
      id: this.id,
    }

    return JSON.stringify(obj, null, '\t')
  }
}
